import {
    STORE_ORDER_PLANNING, STORE_ALL_SHIPPED_FTL,
} from '../../constants/orderPlanning';

const initialState = {
    allOrderPlanning: [],
    allShippedFTL: [],
}



export default (state = initialState, action) => {
    switch(action.type){
        case STORE_ORDER_PLANNING:
            return {
                ...state,
                allOrderPlanning: action.data,
            }
        case STORE_ALL_SHIPPED_FTL:
            return {
                ...state,
                allShippedFTL: action.ftl,
            }
        default:
            return state
    }

}